import React, { useState, useEffect, useRef, memo  } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Modal from 'react-modal';
import ReservationForm from './ReservationForm';
import config from '../config';
import { useIsMobile } from '../Responsive';
import { formatDateTimeGR } from './shared/dateUtils';

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
const AssignMeats = ({ reservation, onCloseModal, onBeforeSave }) => {

  const [meatAssignments, setMeatAssignments] = useState([]);
  const [meats, setMeats] = useState([]);
  const [cooktypes, setCooktypes] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [selectedOnTheSide, setSelectedOnTheSide] = useState(null);
  const [selectAllFilleting, setSelectAllFilleting] = useState(false);
  const [selectAllStandalone, setSelectAllStandalone] = useState(false);
  const [saving, setSaving] = useState(false);

  const navigate = useNavigate();
  const isMobile = useIsMobile();

  // Fetch meats and cooktypes from the API
  useEffect(() => {
    axios.get(tr('{{API_BASE_URL}}/meats', {
      API_BASE_URL: config.API_BASE_URL
    }))
      .then((response) => setMeats(response.data))
      .catch((error) => console.error('Error fetching meats:', error));

    axios.get(tr('{{API_BASE_URL}}/cooktypes', {
      API_BASE_URL: config.API_BASE_URL
    }))
      .then((response) => setCooktypes(response.data))
      .catch((error) => console.error('Error fetching cook types:', error));
  }, []);

  // Fetch assigned meats for the given reservation
  useEffect(() => {
    if (!reservation || !reservation.id) {
      console.error('Invalid reservation ID');
      return;
    }

    axios.get(tr('{{API_BASE_URL}}/assignedmeats/{{id}}', {
      API_BASE_URL: config.API_BASE_URL,
      id: reservation.id
    }))
      .then((response) => {
        const assignments = response.data.map((assignment) => ({
          ...assignment,
          actual_quantity: assignment.actual_quantity ?? assignment.grams ?? '',
          standalone: assignment.standalone?.data[0] === 1,
          ontheside: assignment.ontheside?.data[0] === 1,
          filleting: assignment.filleting?.data?.[0] === 1
        }));
        setSelectedOnTheSide(assignments.findIndex((assignment) => assignment.ontheside));
        setMeatAssignments(assignments.length ? assignments : [{ meat: '', cooktype: '', grams: '', actual_quantity: '', standalone: false, ontheside: false, filleting: false }]);
      })
      .catch((error) => console.error('Error fetching assigned meats:', error));
  }, [reservation]);

  const handleToggleAll = (field, value) => {
    const updated = meatAssignments.map(a => ({ ...a, [field]: value }));
    setMeatAssignments(updated);
    
    if (field === 'filleting') setSelectAllFilleting(value);
    if (field === 'standalone') setSelectAllStandalone(value);
  };

  useEffect(() => {
    // Update selectAllFilleting state
    setSelectAllFilleting(meatAssignments.length == meatAssignments.filter(a => a.filleting).length);
    // Update selectAllStandalone state
    const leftOvers = meatAssignments.filter(a => !a.standalone);
    if(meatAssignments.length>1 && leftOvers.length == 1){
      setTimeout(()=>{leftOvers[0].standalone = true},0);
    }
    setTimeout(()=>{setSelectAllStandalone(meatAssignments.length == meatAssignments.filter(a => a.standalone).length)},100);
  }, [meatAssignments]);

  const audit = React.useMemo(() => {
    const existing = meatAssignments.find(a => a.id);
    if (existing) {
      return {
        created: existing.created,
        created_by_username: existing.created_by_username,
        updated: existing.updated,
        updated_by_username: existing.updated_by_username
      };
    }
    // Fallback to reservation-level audit if available
    if (reservation) {
      return {
        created: reservation.created,
        created_by_username: reservation.created_by_username,
        updated: reservation.updated,
        updated_by_username: reservation.updated_by_username
      };
    }
    return null;
  }, [meatAssignments, reservation]);

  // Handle input field changes
  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updatedAssignments = [...meatAssignments];
    const previousAssignment = { ...updatedAssignments[index] };
    const nextValue = type === 'checkbox' ? checked : value;

    updatedAssignments[index][name] = nextValue;

    if (name === 'grams') {
      const previousRequested = String(previousAssignment.grams ?? '');
      const previousActual = String(previousAssignment.actual_quantity ?? '');
      if (!previousActual || previousActual === previousRequested) {
        updatedAssignments[index].actual_quantity = nextValue;
      }
    }
  
    // Auto-fill defaults when selecting a meat (or clear if no defaults)
    if (name === 'meat') {
      const selectedMeat = meats.find((m) => String(m.id) === String(value));
    
      if (!selectedMeat) {
        // meat cleared or not found -> clear fields
        updatedAssignments[index].grams = '';
        updatedAssignments[index].actual_quantity = '';
        updatedAssignments[index].cooktype = '';
      } else {
        // grams
        if (selectedMeat.default_quantity !== null && selectedMeat.default_quantity !== undefined && selectedMeat.default_quantity !== '') {
          updatedAssignments[index].grams = String(selectedMeat.default_quantity);
          updatedAssignments[index].actual_quantity = String(selectedMeat.default_quantity);
        } else {
          updatedAssignments[index].grams = '';
          updatedAssignments[index].actual_quantity = '';
        }
    
        // cooktype
        if (selectedMeat.default_cooktype !== null && selectedMeat.default_cooktype !== undefined && selectedMeat.default_cooktype !== '') {
          updatedAssignments[index].cooktype = String(selectedMeat.default_cooktype);
        } else {
          updatedAssignments[index].cooktype = '';
        }
      }
    }

    setMeatAssignments(updatedAssignments);
  };


  const check4leftOver = () => {
    //if(meatAssignments.length>1 && meatAssignments.filter(a => !a.standalone).length == 1)
    //  setSelectAllStandalone(true);
  }

  const handleOnTheSideChange = (index) => {
    const isSelected = selectedOnTheSide === index;
    setSelectedOnTheSide(isSelected ? null : index);
    const updatedAssignments = meatAssignments.map((assignment, i) => ({
      ...assignment,
      ontheside: !isSelected && i === index,
    }));
    setMeatAssignments(updatedAssignments);
  };

  const handleAddMeatAssignment = () => {
    setMeatAssignments([
      ...meatAssignments,
      { meat: '', cooktype: '', grams: '', actual_quantity: '', standalone: false, ontheside: false, filleting: false },
    ]);
  };

  const handleDelete = (id, index) => {
    if (id) {
      if(!window.confirm('Delete assigned meat #'+(index+1)+' ?'))
        return;    
      axios.delete(tr('{{API_BASE_URL}}/assignedmeats/{{id}}', {
        API_BASE_URL: config.API_BASE_URL,
        id
      }))
        .then(() => {
          setMeatAssignments((prev) => prev.filter((assignment) => assignment.id !== id));
        })
        .catch(() => setError('Error deleting assignment.'));
    } else {
      setMeatAssignments((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    if (!reservation || !reservation.id) {
        setError('No reservation ID provided.');
        return;
    }

    const data = {
        reservation: reservation.id,
        assignments: meatAssignments.map((assignment) => ({
            id: assignment.id || null, // Include ID if it exists
            meat: assignment.meat,
            cooktype: assignment.cooktype,
            grams: assignment.grams,
            actual_quantity: assignment.actual_quantity || assignment.grams,
            standalone: assignment.standalone,
            ontheside: assignment.ontheside,
            filleting: assignment.filleting
        })),
    };

    try {
      setSaving(true);
      // 1) Persist reservation details (people, status/state, order, comment) first
      if (typeof onBeforeSave === 'function') {
        await onBeforeSave(); // if this throws, meats won't be saved
      }
      // 2) Then save meats
      await axios.post(tr('{{API_BASE_URL}}/assignedmeats/bulk', {
        API_BASE_URL: config.API_BASE_URL
      }), data);
      setMessage('Assignments saved successfully.');
      setError('');
      if (onCloseModal) {
        setTimeout(onCloseModal, 1000);
      } else {
        setTimeout(() => navigate("/reservations-list"), 1000);
      }
    } catch (err) {
      console.error('Save error:', err);
      setError('Error saving assignments.');
    } finally {
      setSaving(false);
    }
  };

  // ---------- MOBILE UI (cards) ----------
  const cardStyle = {
    border: '1px solid #e5e7eb',
    borderRadius: 12,
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
    padding: 12,
    marginBottom: 12,
    background: 'white'
  };
  const labelStyle = {
    display: 'block',
    fontSize: 12,
    color: '#555',
    marginBottom: 4
  };
  const inputStyle = {
    width: '100%',
    padding: '8px 10px',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    boxSizing: 'border-box'
  };
  const smallBtn = {
    border: 'none',
    background: 'transparent',
    padding: 6,
    cursor: 'pointer'
  };

  if (isMobile) {
    return (
      <div style={{ width: '95%', margin: '0 auto', padding: '4px 8px' }}>
        <form onSubmit={handleSubmit}>
          {/* Toolbar: Add left, Save right */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <button
              type="button"
              onClick={handleAddMeatAssignment}
              style={{
                color: 'darkGreen',
                background: 'white',
                fontWeight: 'bold',
                fontSize: 15,
                border: '2px solid darkGreen',
                borderRadius: 18,
                padding: '6px 12px',
                boxShadow: '2px 2px 2px rgba(0,0,0,0.15)'
              }}
            >
              + 
            </button>
            <h2 style={{ margin: '5px' }}>{tr('Assign Meats')}</h2>
            <button
              type="submit"
              disabled={saving}
              style={{
                color: 'white',
                background: saving ? '#9ca3af' : '#0ea5e9',
                fontWeight: 'bold',
                fontSize: 15,
                border: 'none',
                borderRadius: 12,
                padding: '8px 16px',
                boxShadow: '2px 2px 2px rgba(0,0,0,0.15)'
              }}
            >
              {saving ? 'Saving…' : 'Save'}
            </button>
          </div>

          {audit && (
            <div style={{fontSize:12, color:'#555', margin:'6px 2px 10px'}}>
              <div>
                <strong>{tr('Created:')}</strong>{' '}
                {audit.created ? formatDateTimeGR(audit.created) : '—'}
                {audit.created_by_username ? tr('· {{created_by_username}}', {
                  created_by_username: audit.created_by_username
                }) : ''}
              </div>
              {audit.updated && (
                <div>
                  <strong>{tr('Last update:')}</strong>{' '}
                  {formatDateTimeGR(audit.updated)}
                  {audit.updated_by_username ? tr('· {{updated_by_username}}', {
                    updated_by_username: audit.updated_by_username
                  }) : ''}
                </div>
              )}
            </div>
          )}

          {error && <p style={{ color: 'red', marginTop: 4 }}>{error}</p>}
          {message && <p style={{ color: 'green', marginTop: 4 }}>{message}</p>}

          {/* Cards */}
          <div>
            {meatAssignments.map((assignment, index) => {
              return (
                <div key={assignment.id || index} style={cardStyle}>
                  {/* Row 1: Meat */}
                  <div style={{ marginBottom: 8 }}>
                    <label style={labelStyle}>#{index+1}{tr('Meat')}</label>
                    <div style={{ float: 'right', marginTop: '-30px' }}>
                      {(meatAssignments.length > 1 || meatAssignments[0].meat) && (
                        <button
                          type="button"
                          onClick={() => handleDelete(assignment.id, index)}
                          style={smallBtn}
                          aria-label={tr('Remove item')}
                          title={tr('Remove')}
                        >
                          <b style={{ color: 'darkRed', textShadow: '1px 1px 1px rgba(0,0,0,0.2)' }}>{tr('⛌')}</b>
                        </button>
                      )}
                    </div>        
                    <select
                      name="meat"
                      value={assignment.meat}
                      onChange={(e) => handleChange(index, e)}
                      required
                      style={inputStyle}
                    >
                      <option value="" disabled>{tr('Select Meat')}</option>
                      {meats.map((meat) => (
                        <option key={meat.id} value={meat.id}>{meat.name}</option>
                      ))}
                    </select>
                  </div>
                  {/* Row 2: Grams (left) + Cook Type (right) */}
                  <div style={{ display: 'grid', gridTemplateColumns: '110px 110px 1fr', gap: 10, marginBottom: 8 }}>
                    <div>
                      <label style={labelStyle}>{tr('Requested Qty')}</label>
                      <input
                        type="number"
                        name="grams"
                        value={assignment.grams}
                        onChange={(e) => handleChange(index, e)}
                        min="1"
                        step="1"
                        required
                        style={{ ...inputStyle, width: '100%' }}
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>{tr('Actual Qty')}</label>
                      <input
                        type="number"
                        name="actual_quantity"
                        value={assignment.actual_quantity ?? assignment.grams}
                        onChange={(e) => handleChange(index, e)}
                        min="1"
                        step="1"
                        required
                        style={{ ...inputStyle, width: '100%' }}
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>{tr('Cook Type')}</label>
                      <select
                        name="cooktype"
                        value={assignment.cooktype}
                        onChange={(e) => handleChange(index, e)}
                        required
                        style={inputStyle}
                      >
                        <option value="" disabled>{tr('Select Cook Type')}</option>
                        {cooktypes.map((cooktype) => (
                          <option key={cooktype.id} value={cooktype.id}>{cooktype.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* Row 3: Toggles */}
                  <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center', marginTop: 6, zoom: '0.85' }}>
                    {meatAssignments.length > 1 && (
                      <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <input
                          type="checkbox"
                          name="standalone"
                          checked={assignment.standalone}
                          onChange={(e) => { handleChange(index, e); }}
                        />{tr('Standalone')}</label>
                    )}
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <input
                        type="radio"
                        name="ontheside"
                        checked={selectedOnTheSide === index}
                        onChange={() => handleOnTheSideChange(index)}
                      />{tr('On the side')}</label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <input
                        type="checkbox"
                        name="filleting"
                        checked={assignment.filleting}
                        onChange={(e) => handleChange(index, e)}
                      />{tr('Filleting')}</label>
                  </div>
                </div>
              );
            })}          
          </div>
        </form>
      </div>
    );
  }

  // ---------- DESKTOP UI (table) ----------
  return (
    <div style={{width: '95%', margin: 'auto'}}>
      <form onSubmit={handleSubmit}>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:8, marginBottom:6}}>
          <h2 style={{margin:0}}>{tr('Assign Meats and Cook Types')}</h2>
          <button type="submit" disabled={saving} style={{minWidth: 140, padding: 10, borderRadius: 10}}>
            {saving ? 'Saving…' : 'Save Assignments'}
          </button>
        </div>
        
        {audit && (
          <div style={{fontSize:12, color:'#555', margin:'0 0 10px'}}>
            { audit.created && (
              <div>
                <strong>{tr('Created:')}</strong>{' '}
                {formatDateTimeGR(audit.created)}
                {audit.created_by_username ? tr('· {{created_by_username}}', {
                  created_by_username: audit.created_by_username
                }) : ''}
              </div>
            )}
            { audit.updated && (
              <div>
                <strong>{tr('Updated:')}</strong>{' '}
                {formatDateTimeGR(audit.updated)}
                {audit.updated_by_username ? tr('· {{updated_by_username}}', {
                  updated_by_username: audit.updated_by_username
                }) : ''}
              </div>
            )}
          </div>
        )}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {message && <p style={{ color: 'green' }}>{message}</p>}

        <table style={{ width: '100%', margin: 'auto', borderCollapse: 'collapse', marginBottom: '15px' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '8px' }}>
              <button style={{color: 'darkGreen', background: 'white', fontWeight: 'bold', fontSize: '15px', border: '2px solid darkGreen', borderRadius: '12px', marginRight: '15px', boxShadow: '2px 2px 2px gray'}} type="button" onClick={handleAddMeatAssignment}>
                  +
              </button>{tr('Meat')}</th>
              <th style={{ textAlign: 'center', padding: '8px' }}>{tr('Requested Qty')}</th>
              <th style={{ textAlign: 'center', padding: '8px' }}>{tr('Actual Qty')}</th>
              <th style={{ textAlign: 'left', padding: '8px' , width: '150px'}}>{tr('Cook Type')}</th>
              <th style={{ textAlign: 'center', padding: '8px', whiteSpace: 'nowrap' }}>
                <div>
                  {meatAssignments.length > 1 && (
                    <input
                      type="checkbox"
                      style={{position: 'relative', bottom: '-5px'}}
                      checked={selectAllStandalone}
                      onChange={(e) => handleToggleAll('standalone', e.target.checked)}
                    />
                  )}{tr('Stand Alone')}</div>
              </th>
              <th style={{ textAlign: 'center', padding: '8px', whiteSpace: 'nowrap' }}>{tr('On the Side')}</th>
              <th style={{ textAlign: 'center', padding: '8px', whiteSpace: 'nowrap' }}>
                <div>
                  {meatAssignments.length > 1 && (
                    <input
                      type="checkbox"
                      style={{position: 'relative', bottom: '-5px'}}
                      checked={selectAllFilleting}
                      onChange={(e) => handleToggleAll('filleting', e.target.checked)}
                    />
                  )}{tr('Filleting')}</div>
              </th>
              <th style={{ textAlign: 'center', padding: '8px' }}>{tr('Remove')}</th>
            </tr>
          </thead>
          <tbody>
            {meatAssignments.map((assignment, index) => {
              return (
                <React.Fragment key={assignment.id || index}>
                  <tr style={{ borderBottom: '1px solid #ccc' }}>
                    {/* Meat Dropdown */}
                    <td style={{ padding: '8px' }}>
                      <select
                        name="meat"
                        value={assignment.meat}
                        onChange={(e) => handleChange(index, e)}
                        required
                        style={{ width: '100%' }}
                      >
                        <option value="" disabled>{tr('Select Meat')}</option>
                        {meats.map((meat) => (
                          <option key={meat.id} value={meat.id}>
                            {meat.name}
                          </option>
                        ))}
                      </select>
                    </td>
            
                    {/* Requested quantity input */}
                    <td style={{ padding: '8px', textAlign: 'center' }}>
                      <input
                        type="number"
                        name="grams"
                        value={assignment.grams}
                        onChange={(e) => handleChange(index, e)}
                        min="1"
                        step="1"
                        required
                        style={{ width: '60px' }}
                      />
                    </td>

                    {/* Actual quantity input */}
                    <td style={{ padding: '8px', textAlign: 'center' }}>
                      <input
                        type="number"
                        name="actual_quantity"
                        value={assignment.actual_quantity ?? assignment.grams}
                        onChange={(e) => handleChange(index, e)}
                        min="1"
                        step="1"
                        required
                        style={{ width: '60px' }}
                      />
                    </td>
            
                    {/* Cook Type Dropdown */}
                    <td style={{ padding: '8px' }}>
                      <select
                        name="cooktype"
                        value={assignment.cooktype}
                        onChange={(e) => handleChange(index, e)}
                        required
                        style={{ width: '100%' }}
                      >
                        <option value="" disabled>{tr('Select Cook Type')}</option>
                        {cooktypes.map((cooktype) => (
                          <option key={cooktype.id} value={cooktype.id}>
                            {cooktype.name}
                          </option>
                        ))}
                      </select>
                    </td>
            
                    {/* Standalone Checkbox */}
                    <td style={{ textAlign: 'center', padding: '8px' }}>
                      {meatAssignments.length > 1 && (
                        <input
                          type="checkbox"
                          name="standalone"
                          checked={assignment.standalone}
                          onChange={(e) => {handleChange(index, e);}}
                        />
                      )}
                    </td>
                    
                    {/* On the Side Radio Button */}
                    <td style={{ textAlign: 'center', padding: '8px' }}>
                      <input
                        type="radio"
                        name="ontheside"
                        checked={selectedOnTheSide === index}
                        onClick={() => handleOnTheSideChange(index)}
                        onChange={() => handleOnTheSideChange(index)}
                      />
                    </td>
            
                    {/* Filleting Checkbox */}
                    <td style={{ textAlign: 'center', padding: '8px' }}>
                      <input
                        type="checkbox"
                        name="filleting"
                        checked={assignment.filleting}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </td>
            
                    {/* Actions: Delete Button */}
                    <td style={{ textAlign: 'center', padding: '8px' }}>
                      {(meatAssignments.length > 1 || meatAssignments[0].meat) && (
                        <button style={{border: 'none', background: 'white'}} type="button" onClick={() => handleDelete(assignment.id, index)}>
                          <b style={{color: 'darkRed', textShadow: '2px 1px 2px gray'}}>{tr('⛌')}</b>
                        </button>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </form>
    </div>
  );
};

export default memo(AssignMeats);
